import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container } from "@/components/layout/Container";
import { Button } from "@/components/ui/button";

export function CTASection() {
  return (
    <section className="cta-gradient py-16 md:py-24">
      <Container>
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Transform Your Surveys?
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8">
            Join thousands of research teams who save hours every week with AI-powered survey creation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/auth">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto">
                Get Started Free
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button 
                size="lg" 
                variant="outline" 
                className="w-full sm:w-auto bg-transparent text-white border-white hover:bg-white/10"
              >
                Contact Sales
              </Button>
            </Link>
          </div>
          <p className="mt-6 text-sm text-white/70">
            No credit card required. Start with 3 free surveys.
          </p>
        </div>
      </Container>
    </section>
  );
}
